const state = {
    danmukuList:[], //弹幕列表
    applyRtc: false, // 发起连麦申请
    receiveApply: false,//收到连麦申请
    approveRtc: false, // 同意连麦
    disapproveRtc: false, // 拒绝连麦
    creatorId: '',
    isScreenPublishing: false, // 屏幕共享
    micList: [], // 连麦列表
    classStatus: 1, // 上课状态
    isJoinedMeeting: false, // 是否属于连麦成员
    connected:false,//用户已连麦
    isMeeting:false, // 当前直播间是否在连麦
    allowed:true,
    isVideoPublishing:'',// 是否直播
    isCameraPublishing:true,// 摄像头开启
    isAudioPublishing:true, // 麦克风开启
    allowOpenMic:true, // 主播允许打开麦克风
    allowOpenCamera:true, // 主播允许打开摄像头
    isBlacklist:false, //用户是否被拉黑
}
const mutations = {
    SET_DANMUKULIST:(state,danmukuList) => {
        state.danmukuList = danmukuList
    }
}
const actions = {
    pushDanmuku:({commit},state,danmuku) => {
        let danmukuList = state.danmukuList;
        danmukuList.push(danmuku)
        commit('SET_DANMUKULIST',danmukuList)
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}